/**
 * 单一状态树
 * vuex 操作顺序：state.js -> mutations-type.js -> mutations.js -> getters.js
 */
const state = {
  portOrg: localStorage.getItem('portOrg') || 0,
  adminIdentity: localStorage.getItem('adminIdentity')
    ? JSON.parse(localStorage.getItem('adminIdentity'))
    : [],
  adminIdentityIndex: localStorage.getItem('adminIdentityIndex')
    ? Number(localStorage.getItem('adminIdentityIndex'))
    : 0,
  theUserIdentity: localStorage.getItem('theUserIdentity'),
  schoolList: [], // 学校信息列表
  schoolIndex: 0, // 学校列表index
  currentRouteInfo: '', // 当前路由信息
  routeList: localStorage.getItem('routeList')
    ? JSON.parse(localStorage.getItem('routeList'))
    : [], // 路由列表信息
  leftNavList: localStorage.getItem('leftNavList')
    ? JSON.parse(localStorage.getItem('leftNavList'))
    : [], // 左侧导航菜单
  // leftNavLists: [], // 左侧导航菜单
  topNavActive: '', // 顶部 active 项
  leftNavOpen: [], // 左侧导航菜单,展开项
  leftNavActive: '', // 左侧导航菜单 active 项
  fileUploadToken: '',
  fileUploadUrl: '', // 上传文件接口
  userInfo: localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : {},
  cacheRoute: [], // 缓存的组件
  baseUrl: process.env.BASE_URL ? process.env.BASE_URL : window.location.origin,
  tabsList: sessionStorage.getItem('tabsList')
    ? JSON.parse(sessionStorage.getItem('tabsList'))
    : [],
  isLevel4: false,
  orgByOpe: [],
  schByOpe: [],
  checkStuListStore: [],
  leftSwitch: true,
  routeTitle: '',
  columnsModule: localStorage.getItem('columnsModule')
    ? JSON.parse(localStorage.getItem('columnsModule'))
    : {}, // {key:[]}  key = 'moduleId'
  keepAliveInclude: [], // 要缓存的组件
  keepAliveComponentInstance: null, // 内容区缓存实例
  browsingHistoryList: localStorage.getItem('browsingHistoryList')
    ? JSON.parse(localStorage.getItem('browsingHistoryList'))
    : {}, // 浏览记录列表
  authMap: localStorage.getItem('430AuthMap')
    ? JSON.parse(localStorage.getItem('430AuthMap'))
    : {}, // 权限集合  1有权限，0无
  //  运营端：
  // 教师考勤确认财务审批：TEA_SHEET_AUDIT
  // 分账规则配置：SETTING_DIVIDE_RULE
  // 开启/禁用系统通知：CLOSE_OPEN_SYS_NOTION
  // 配置教师课酬梯度设置：SETTING_TEA_FEE_ALLOT
  // 学校端：
  // 教师考勤确认学校审批：TEA_SHEET_SCH_AUDIT
  ifRouterAlive: true, // 是否要刷新 内容区域router-view

  schoolIdForState: localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '', // 选择的学校id
  schoolNameForState: localStorage.getItem('schoolName') ? localStorage.getItem('schoolName') : '', // 选择的学校名称
  // noFunctionRouterListName: ['courseSchedulCenter_divideClassTimeTable_schoolTimeTable', 'eduCenter_studentAttance_NormalClassIndex']
  noFunctionRouterListName: [],
  isMaoming: window.location.origin === 'https://mmkh.gzhtedu.cn', // 是否是茂名的430
  projectName: window.location.origin === 'https://mmkh.gzhtedu.cn' ? '选课报名服务' : '宏兔兔课后托管'
};

export default state;
